import CircularProgress from '@/components/CircularProgress/CircularProgress';
import Typography from '@/components/Typography/Typography';
import React from 'react';
import useIamAccount from '@/hooks/useIamAccount';
import I18N_RESOURCE from '@/i18n/template';
import { useTranslation } from 'react-i18next';

/**
 * The props for the AccountNameText component
 * @interface Props
 */
interface Props {
  /**
   * The account ID
   * @type {string | undefined}
   */
  accountId?: string;
}

const styles = {
  subheaderText: {
    margin: '0',
    color: '#FFF',
    fontSize: '1.125rem',
    fontStyle: 'normal',
    fontWeight: '700',
    lineHeight: '2rem',
    letterSpacing: '-0.1px',
    display: 'flex',
    alignItems: 'center',
  },
  circularProgress: { color: 'white.main' },
};

/**
 * The AccountNameText component
 */
const AccountNameText = (props: Props) => {
  const { accountId } = props;
  const { data: iamAccount, isFetching: isIamAccountLoading, error } = useIamAccount({ accountId });
  const { t } = useTranslation();

  if (accountId == null || accountId === '') {
    const accountNotFoundLabel = t('TRIMBLE_LAYOUT.HEADER.ACCOUNT_NOT_FOUND', {
      defaultValue: I18N_RESOURCE.TRIMBLE_LAYOUT.HEADER.ACCOUNT_NOT_FOUND,
    });

    return (
      <Typography variant={'h5'} style={styles.subheaderText}>
        {accountNotFoundLabel}
      </Typography>
    );
  }

  if (isIamAccountLoading) {
    return <CircularProgress size={26} sx={styles.circularProgress} />;
  }

  if ((error && iamAccount == null) || iamAccount?.name == null || iamAccount.name === '') {
    const accountNameNotFoundLabel = t('TRIMBLE_LAYOUT.HEADER.ACCOUNT_NAME_NOT_FOUND', {
      defaultValue: I18N_RESOURCE.TRIMBLE_LAYOUT.HEADER.ACCOUNT_NAME_NOT_FOUND,
      accountId,
    });

    return (
      <Typography variant={'h5'} style={styles.subheaderText}>
        {accountNameNotFoundLabel}
      </Typography>
    );
  }

  return (
    <Typography variant={'h5'} style={styles.subheaderText}>
      {iamAccount?.name}
    </Typography>
  );
};

export default AccountNameText;
